import { UserChangePasswordResult,UserChangePasswordDialogComponent } from './../user/user-edit/user-change-password-dialog/user-change-password-dialog.component';
import { Component, Input } from '@angular/core';
import { MatLegacyDialog } from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { ChangePasswordParameter, CtProfileService } from '@ctsolution/ct-authentication';


@Component({
  selector: 'app-change-password-card',
  templateUrl: './change-password-card.component.html',
  styleUrls: ['./change-password-card.component.scss']
})
export class ChangePasswordCardComponent {

  @Input() title: string = 'Sicurezza';
  @Input() description: string = 'Modifica la tua password';
  @Input() buttonLabel: string = 'Modifica Password';

  constructor(
    private dialog: MatLegacyDialog,
    private profileService: CtProfileService,
    private snackBar: MatSnackBar
  ) {}

  async openChangePasswordDialog(): Promise<void> {

    const dialogRef = this.dialog.open(UserChangePasswordDialogComponent, {
      width: '500px',
      disableClose: true
    });

    const result: UserChangePasswordResult = await dialogRef.afterClosed().toPromise();

    if (result?.confirmed) {

      if(!result.oldPassword || !result.newPassword) {
        this.showErrorMessage('I campi password sono obbligatori');
        return;
      }

      this.profileService.changePassword(
        new ChangePasswordParameter(result.oldPassword, result.newPassword)
      ).subscribe({
        next: () => {
          this.showSuccessMessage('Password modificata con successo');
        },
        error: (err) => {
          console.error('Errore durante il cambio password:', err);
          const errorMessage = this.getErrorMessage(err);
          this.showErrorMessage(errorMessage);
        }
      });

    }
  }

  private getErrorMessage(err: any): string {

    if (err?.error?.message) {
      return err.error.message;
    }

    if (err?.status === 401 || err?.status === 403) {
      return 'La vecchia password non è corretta';
    }

    if (err?.status === 400) {
      return 'La nuova password non soddisfa i requisiti richiesti';
    }

    return 'Errore durante la modifica della password. Riprova più tardi';
  }

  private showSuccessMessage(message: string): void {
    this.snackBar.open(message, 'Chiudi', {
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: ['success-snackbar']
    });
  }

  private showErrorMessage(message: string): void {
    this.snackBar.open(message, 'Chiudi', {
      duration: 7000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: ['error-snackbar']
    });
  }

}
